var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { runtime } from '../runtime/Runtime';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { EventAspect } from './modules/EventAspect';
import { eventRegistry } from '../../registry/Registry';
import { EventAttachedAction } from './modules/EventAttachedAction';
export class Event_ {
    rawEvent;
    constructor({ aspect, rawEvent, actionAt }) {
        this.rawEvent = rawEvent;
        if (aspect) {
            this.eventAspect.aspect = aspect;
        }
        if (actionAt) {
            this.eventAttachedAction.currentActionAt = actionAt;
        }
    }
    get type() {
        return this.rawEvent.type;
    }
    get app() {
        return runtime.solidBrowserRuntime.app;
    }
    get reg() {
        return eventRegistry.registry_object[this.type];
    }
    appTime = runtime.solidBrowserRuntime.app.appClock.currentTime;
    runtimeTime = runtime.runtimeClock.currentTime;
    get eventAspect() {
        return new EventAspect(this);
    }
    get eventAttachedAction() {
        return new EventAttachedAction(this);
    }
    get domTarget() {
        return this.reactEvent.currentTarget;
    }
    get context() {
        return this.app.context;
    }
    get reactEvent() {
        return this.rawEvent;
    }
}
__decorate([
    memoize
], Event_.prototype, "eventAspect", null);
__decorate([
    memoize
], Event_.prototype, "eventAttachedAction", null);
